/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Hero_BreadcrumbInputs */

const es_l6_hero_breadcrumb = /** @type {(inputs: L6_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter`)
};

const gl_l6_hero_breadcrumb = /** @type {(inputs: L6_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter`)
};

const en_l6_hero_breadcrumb = /** @type {(inputs: L6_Hero_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter`)
};

/**
* | output |
* | --- |
* | "Charter" |
*
* @param {L6_Hero_BreadcrumbInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_hero_breadcrumb = /** @type {((inputs?: L6_Hero_BreadcrumbInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Hero_BreadcrumbInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_hero_breadcrumb(inputs)
	if (locale === "en") return en_l6_hero_breadcrumb(inputs)
	return es_l6_hero_breadcrumb(inputs)
});